export const Types = {
  RETRIEVE_CITIES_OF_STATE_REQUEST: '[citiesState]RETRIEVE_CITIES_OF_STATE_REQUEST',
  RETRIEVE_CITIES_OF_STATE_SUCCESS: '[citiesState]RETRIEVE_CITIES_OF_STATE_SUCCESS',
  RETRIEVE_CITIES_OF_STATE_FAILURE: '[citiesState]RETRIEVE_CITIES_OF_STATE_FAILURE',
};
